import React, { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { Outlet, useParams } from 'react-router-dom'

import css from './AuthLayout.module.scss'
import Nav from './Nav/Nav'
import Menu from './Menu/Menu'
import {
  accountReset,
  audienceReset,
  campaignReset,
  templateReset,
  organizationLoad,
  statsReset
} from '../../../redux/actions'

const AuthLayout = ({ auth, organization }) => {
  const dispatch = useDispatch()
  const { orgId } = useParams()

  useEffect(() => {
    if (!organization.init && auth.me) {
      dispatch(organizationLoad())
    }
  }, [organization.init, dispatch, auth.me])

  useEffect(() => {
    if (!orgId) return
    dispatch(statsReset())
    dispatch(accountReset())
    dispatch(audienceReset())
    dispatch(campaignReset())
    dispatch(templateReset())
  }, [dispatch, orgId])

  return (
    <div className={css.AuthLayout}>
      <Nav me={auth.me} />
      <Menu />
      <main className={css.Container}>
        <Outlet />
      </main>
    </div>
  )
}

export default connect((state) => {
  return state
})(AuthLayout)
